$(document).ready(function(){
// var swiper = new Swiper(".collection_swiper_slider", {
//     slidesPerView: "auto",
//     freeMode: true,
//     spaceBetween: 12,
//      slidesPerView: 11,
//     navigation: {
//       nextEl: ".swiper-button-nextcollection",
//       prevEl: ".swiper-button-prevcollection",
//     },
//     breakpoints: {
//       640: {
//         slidesPerView: "auto",
//         spaceBetween: 12,
//       },
//       768: {
//         slidesPerView: "auto",
//         spaceBetween: 12,
//       },
//       1024: {
//         slidesPerView: "auto",
//         spaceBetween: 32,
//       },
//       1200: {
//         slidesPerView: "auto",
//         spaceBetween: 32,
//       },
//     },
//   });

  $('.colection_inner_main .swiper-wrapper').slick({
  dots: false,
  speed: 300,
  infinite: false,
  slidesToShow: 11,
  slidesToScroll: 1,
     responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 10,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1
      }
    },
     {
     breakpoint: 750,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    }
  ]
});
        $('.home_featured_collection slider-component ul.product-grid').slick({
        dots: false,
        infinite: false,
        speed: 300,
          centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [          
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
            }
          }
          
        ]
      });

  $('.home_featured_collection_list ul.collection-list').slick({
        dots: false,
        infinite: false,
        speed: 300,
          centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [          
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
            }
          }
          
        ]
      });
      $('.custom-review .review_inner_main').slick({
      dots: false,
      speed: 300,
      infinite: true,
      fade: true,
    cssEase: 'linear'   
    });
  
  setTimeout(function(){
      $('product-recommendations ul').slick({
        dots: false,
        infinite: false,
        speed: 300,
          centerMode: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [          
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
            }
          }
          
        ]
    });
   },5000)
        $(document).on("click", ".home_featured_collection .cust_featur_title .featured_coll_main_arrows span.icon_prev", function(){
          $(this).parents(".cust_featur_title").next().find("button.slick-prev").trigger("click")
      })
      $(document).on("click", ".home_featured_collection .cust_featur_title .featured_coll_main_arrows span.icon_next", function(){
          $(this).parents(".cust_featur_title").next().find("button.slick-next").trigger("click")
      })

     $(document).on("click", ".home_featured_collection_list .cust_btn_title .cust_btn_title_main-arrows", function(){
          $(this).parents(".cust_btn_title").next().find("button.slick-prev").trigger("click")
      })
      $(document).on("click", ".home_featured_collection_list .cust_btn_title .cust_btn_title_main-arrows span.icon_next", function(){
          $(this).parents(".cust_btn_title").next().find("button.slick-next").trigger("click")
      })
    $(document).on("click", ".recomm_main_head span.icon_next", function(){
          $(this).parents(".recomm_main_head").next().find("button.slick-next").trigger("click")
          console.log("aa")
      })
    $(document).on("click", ".recomm_main_head span.icon_prev", function(){
          $(this).parents(".recomm_main_head").next().find("button.slick-prev").trigger("click")
          console.log("aa")
      })
           
          if ($(window).width() < 767)(
            $(document).on("click","footer.footer h2.footer-block__heading.mob_footer_acc", function(){
              $(this).toggleClass('active');
              $(this).next().slideToggle();
            })
           )

  
        $(document).on("click",".cust_filter_cions", function(){
            $('#FacetsWrapperDesktop').toggleClass("active");
            $(this).parents('#FacetFiltersForm').find('.collection_main_fileter').toggleClass("activeFilter");
        });
  
  })  // end document ready